
import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { Button } from "./ui/button";

const FloatingButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 100;
      setIsVisible(scrolled);
      
      // Update hero button visibility through a custom event
      window.dispatchEvent(new CustomEvent('floatingButtonVisibility', { 
        detail: { isVisible: scrolled } 
      }));
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div 
      className={`fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[-100vh]'
      }`}
    >
      <Button
        size="lg"
        asChild
        className="bg-accent hover:bg-accent-hover text-accent-light text-black px-12 py-8 text-xl transform hover:scale-110 transition-all duration-300 animate-[wiggle_1s_ease-in-out_1s_7,wiggle_1s_ease-in-out_8s_7,wiggle_1s_ease-in-out_15s_7,wiggle_1s_ease-in-out_22s_7,wiggle_1s_ease-in-out_29s_7,wiggle_1s_ease-in-out_36s_7,wiggle_1s_ease-in-out_43s_7,wiggle_1s_ease-in-out_50s_7,wiggle_1s_ease-in-out_57s_7,wiggle_1s_ease-in-out_64s_7,wiggle_1s_ease-in-out_71s_7,wiggle_1s_ease-in-out_78s_7,wiggle_1s_ease-in-out_85s_7,wiggle_1s_ease-in-out_92s_7,wiggle_1s_ease-in-out_99s_7]"
        aria-label="Floating menu button - Schedule a diagnosis"
      >
        <a href="tel:18007939081" className="inline-flex items-center">
          <Phone className="mr-2 animate-pulse" /> Schedule a diagnosis
        </a>
      </Button>
    </div>
  );
};

export default FloatingButton;
